import { NavigationGuardNext, RouteLocation, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"
import flow1Routes from "@/modules/enrollment-new/pages/flow1-vpc-family-plus/routes"
import flow2Routes from "@/modules/enrollment-new/pages/flow2-vpc-mec/routes"
import flow3Routes from "@/modules/enrollment-new/pages/flow3-vpc-mec2/routes"
import flow4Routes from "@/modules/enrollment-new/pages/flow4-mec2-only/routes"
import flow5Routes from "@/modules/enrollment-new/pages/flow5-vpc-family/routes"

export default [
  {
    path: "/enrollment-layout-enrollment",
    component: () => import("@/layouts/enrollment-new/EnrollmentLayout.vue"),
    children: [
      {
        path: "/enroll-new",
        name: "enrollment-landing",
        props: (route: RouteLocation) => ({
          companyBenefitEnrollmentId: route.query.enrollment,
          defaultEmailOrPhone: route.query.for,
          publicCompanyId: route.query.cID,
          from: route.query.from,
          messageCount: route.query.c,
          planType: route.query.plan?.toString().toLowerCase(),
          planMinCost: route.query.min,
          campaignVersion: route.query.e
        }),
        component: () => import("@/modules/enrollment-new/pages/enrollment-landing/EnrollmentLandingPage.vue")
      },
      {
        path: "/enroll/start",
        name: "enroll-new-start",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () => import("@/modules/enrollment-new/pages/enrollment-router/EnrollmentRouterScreen.vue")
      },

      ...flow1Routes,
      ...flow2Routes,
      ...flow3Routes,
      ...flow4Routes,
      ...flow5Routes,

      // ---- start: POST ENROLLMENT FLOW :-------------
      {
        path: "/enroll/welcome-call",
        name: "enrollment-welcome-call",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () =>
          import("@/modules/enrollment-new/pages/post-enrollment-flow/Step1-EnrollmentFlowWelcomeCallPage.vue")
      },
      {
        path: "/enroll/schedule-visit",
        name: "enrollment-schedule-visit",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () =>
          import("@/modules/enrollment-new/pages/post-enrollment-flow/Step2-EnrollmentFlowScheduleVisitPage.vue")
      },
      {
        path: "/enroll/download-app",
        name: "enrollment-download-app",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () =>
          import("@/modules/enrollment-new/pages/post-enrollment-flow/Step3-EnrollmentFlowDownloadAppPage.vue")
      }
      // –– end: POST ENROLLMENT FLOW :———––
    ]
  }
]
